import { INFO_SUBJECT_MATTERS_MESSAGES } from '@app/utils/constants';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { SimpleTooltip } from '@shared/components/simple-tooltip';
import { cn } from '@shared/lib/utils';

interface DashboardSectionInterface {
  title: string;
  tooltipContent: string;
  children: React.ReactNode;
}

function DashboardSection({
  title,
  tooltipContent,
  children,
}: DashboardSectionInterface) {
  return (
    <div className={cn('mb-5')}>
      <div className="mb-5 flex items-center">
        <Text className="mr-2 text-xl font-medium">{title}</Text>
        <SimpleTooltip
          trigger={<Icons.help size={22} />}
          content={INFO_SUBJECT_MATTERS_MESSAGES[tooltipContent]}
          className="max-w-xl"
        />
      </div>
      {children}
    </div>
  );
}

export default DashboardSection;
